// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-3-player-profile .v-list-item-group .v-list-item--active {\n    border-width: 0.11px !important;\n    border-color: rgba(255, 255, 255, 50%) !important;\n    border-style: solid !important;\n    border-radius: 5px !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
